import countryList from "react-select-country-list";
import passwordValidator from "password-validator";
import emailvalidator from "email-validator";

var CURRENCY_TO_COUNTRY_MAP = {
  USD: "us",
  EUR: "eu",
  SGD: "sg",
  AUD: "au",
  GBP: "gb",
  CHF: "ch",
  JPY: "jp",
  NZD: "nz",
  CAD: "ca",
  HKD: "hk",
  CNY: "cn",
  CNH: "cn",
  KRW: "kr",
  IDR: "id",
  MYR: "my",
  PHP: "ph",
  THB: "th",
  VND: "vn",
  KHR: "kh",
  INR: "in",
  SEK: "se",
  NPR: "np",
  DKK: "dk",
  BDT: "bd",
  BND: "bn",
  AED: "ae",
  PKR: "pk",
  QAR: "qa",
  LKR: "lk",
  TWD: "tw"
};

export let getCountryCodeForCurrency = currencyCode => {
  const countryCode = CURRENCY_TO_COUNTRY_MAP[currencyCode] || "";
  // console.log(`Currency Code: ${currencyCode}, Mapped Country Code: ${countryCode}`);
  return countryCode;
};
export var isNumber = n => {
  return !isNaN(parseFloat(n)) && !isNaN(n - 0)
}

export var displayNumberWithComma = x => {
  if (!x) {
    return x;
  }
  if (isNumber(x)) {
    return formatDouble(x,2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return x;
  }
}
export var formatDouble = (x, precision) => {
  if (!x) {
    return x;
  }
  return parseFloat(x).toFixed(precision);
};

export var formatExchangeRate = x => {
  return formatDouble(x, 4);
};

export var formatMoney = x => {
  return formatDouble(x, 2);
};

export var formatMoneyValue = moneyValue => {
  let amount = moneyValue.amount;
  if(moneyValue.currency ==='VND' || moneyValue.currency ==='IDR'){
    amount = Math.round(moneyValue.amount);
  }
  return moneyValue.currency + " " + displayNumberWithComma(amount);
};

export function getCountryNameByCode(countryCode) {
  if (!countryCode) {
    return null;
  }
  return countryList().getLabel(countryCode);
}

export const getCountryCodeByLabel = label => {
  if (!label) {
    return null;
  }
  return countryList().getValue(label);
};

export const validatePassword = password => {
  const passwordSchema = new passwordValidator();

  passwordSchema
    .is()
    .min(8)
    .has()
    .uppercase()
    .has()
    .lowercase()
    .has()
    .not()
    .spaces()
    .has();

  return passwordSchema.validate(password);
};

export const validateEmail = email => emailvalidator.validate(email);

export const getSearchParamValueByName = name => {
  const url = window.location.href;
  name = name.replace(/[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const formatPhoneNumber = number => {
  if(number){
    const parts = number.split(' ');
    return `+${parts[1]} ${parts[0]}`
  }else{
    return ''
  }
};
